import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import CssBaseline from "@mui/material/CssBaseline";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Container from "@mui/material/Container";
import Link from "@mui/material/Link";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import React from "react";
import Eventcards from "./Eventcards";

const cards = [1, 2, 3];



const theme = createTheme();

export default function Slider() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <main>
        
          <Box
            sx={{
              bgcolor: "background.paper",
              pt: 6,
              pb: 4,
            }}
          >
            <Container maxWidth="sm">
              <Typography
                component="h2"
                variant="h3"
                align="center"
                color="text.primary"
                gutterBottom
                style={{ fontWeight: "bold" }}
              >
                Upcoming Events
              </Typography>
              <Typography variant="h6" align="center" color="text.secondary" paragraph>
                We host Massive Events with Experts, Concerts, BootCamps,
                Hackathons & Much more.
              </Typography>
              
            </Container>
          </Box>
          <Eventcards />
      </main>
    </ThemeProvider>
  );
}
